import { createTheme } from '@mui/material'

declare module '@mui/material/styles' {
  interface Palette {
    tertiary: Palette['primary']
  }

  interface PaletteOptions {
    tertiary?: PaletteOptions['primary']
  }
}

export enum ThemePalette {
  // FONT_GLOBAL = 'Montserrat',
  FONT_GLOBAL = 'Open Sans',
  RED_MEDIUM = '#DE1F1F',
  GREEN_MEDIUM = '#25AE33',
  GRAY_LIGHT = '#F2F4FB',
  GRAY_MEDIUM = '#A3AFBB',
  PRIMARY = '#FFDA00',
  SECONDARY = '#2f3b55',
  TERTIARY = '#232A32',
  TEXT_PRIMARY = '#232A32',
  TEXT_SECONDARY = '#9097AE',
  WHITE_MEDIUM = '#fff',
  LINK = '#0C80D3',
}

export const DEFAULT_THEME = createTheme({
  components: {
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            // backgroundColor: 'transparent',
            border: '2.5px solid #FFDA00AA',
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: 'white',
        },
      },
    },
    MuiBreadcrumbs: {
      styleOverrides: {
        separator: {
          marginLeft: '2px',
          marginRight: '2px',
        },
      },
    },
    MuiListItemSecondaryAction: {
      styleOverrides: {
        root: {
          right: '2px',
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          minHeight: '56px',
          '&.Mui-selected': {
            fontWeight: 700,
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          height: '2.8px',
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: ThemePalette.TERTIARY,
        },
      },
    },
    MuiAvatar: {
      styleOverrides: {
        colorDefault: {
          background: '#FFDA00',
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: '#A3AFBB',
          fontWeight: 400,
          // fontSize: '12px',
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: '#A3AFBB',
          fontWeight: 400,
          fontSize: '0.9rem',
          // fontSize: '12px',
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          color: '#505860',
          fontWeight: 500,
          // fontSize: '12px',
        },
        input: {
          // padding: '0px !important',
        },
      },
    },
    // MuiInput: {
    //   styleOverrides: {
    //     underline: {
    //       '&:before': {
    //         borderBottom: '1px solid green',
    //       },
    //     },
    //   },
    // },
  },

  typography: {
    allVariants: {
      // color: '#2f3b55',
      // color: ThemePalette.TEXT_PRIMARY,
    },
    fontFamily: ThemePalette.FONT_GLOBAL,
  },

  palette: {
    mode: 'light',
    primary: {
      main: ThemePalette.PRIMARY,
      contrastText: '#000',
      light: '#FFFBE6',
    },
    secondary: {
      main: ThemePalette.SECONDARY,
      contrastText: '#fff',
      light: '#D1D5E0',
    },
    tertiary: {
      main: ThemePalette.TERTIARY,
      contrastText: '#fff',
      light: '#D1D5E0',
      dark: '#1b2128',
    },
    text: {
      primary: ThemePalette.TEXT_PRIMARY,
      secondary: ThemePalette.TEXT_SECONDARY,
    },
  },

  // overrides: {
  //   // Style sheet name ⚛️
  //   MuiButton: {
  //     contained: {
  //       borderRadius: 20,
  //       color: 'white',

  //       boxShadow: 'none',
  //     },
  //     text: {
  //       // Some CSS
  //       color: 'white',
  //     },
  //   },
  // },
})

export const DEFAULT_THEME_RAINBOW = {
  rainbow: {
    palette: {},
  },
}
